import { CaseUtil } from '@vectord/utils';

export enum TimeBufferUnit {
  MINUTES = 'minutes',
  HOURS = 'hours',
  DAYS = 'days',
  WEEKS = 'weeks',
  MONTHS = 'months',
  YEARS = 'years',
}

// Only sub-day units are offered. The enum and UNIT_MINUTES below deliberately keep the wider
// set: automations saved before this narrowing still hold days/weeks/months/years, and those
// must keep resolving and rendering rather than reading as an unknown unit.
const OFFERED_UNITS = [TimeBufferUnit.MINUTES, TimeBufferUnit.HOURS];

export const timeBufferUnitOptions = OFFERED_UNITS.map((value) => ({
  label: CaseUtil.titleCase(value),
  value,
}));

export const timeBufferDirectionOptions = [
  { label: 'After', value: true },
  { label: 'Before', value: false },
];

export const AUTOMATION_EXECUTION_TIME = 'Automation Execution Time';

export const TIME_BUFFER_FEATURE = 'Automation Time Buffer';
export const MAX_BUFFER_MINUTES_CONFIG_KEY = 'max_buffer_minutes';

export const UNIT_MINUTES: Record<TimeBufferUnit, number> = {
  [TimeBufferUnit.MINUTES]: 1,
  [TimeBufferUnit.HOURS]: 60,
  [TimeBufferUnit.DAYS]: 60 * 24,
  [TimeBufferUnit.WEEKS]: 60 * 24 * 7,
  [TimeBufferUnit.MONTHS]: 60 * 24 * 30,
  [TimeBufferUnit.YEARS]: 60 * 24 * 365,
};

// Mirrors the ceiling AutomationExecutors::TimeResolver clamps to, so the input cannot
// offer a value the executor would silently shrink.
export const maxValueForUnit = (unit: TimeBufferUnit, maxMinutes?: number): number | undefined => (
  maxMinutes && maxMinutes > 0 ? Math.max(1, Math.floor(maxMinutes / UNIT_MINUTES[unit])) : undefined
);
